import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import ModalConvocatoria from '../Modal/ModalConvocatoria';
import './inicio.css';
import './banner.css';
import './graphic.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';

const Inicio = () => {
  const [isModalOpen, setModalOpen] = useState(true);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const closeModal = () => {
    setModalOpen(false);
  };  

  return (
    <>
      
      <Carousel/>
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Trabajo.svg")` }}>

            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DEL TRABAJO</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La Secretaría del Trabajo y Previsión Social tiene como funciones, vigilar la observancia y aplicación de las disposiciones en materia laboral contenidas en la Constitución Política de los Estados Unidos Mexicanos, en la Constitución Política del Estado Libre y soberano de Hidalgo, en Ley Federal del Trabajo y en la Ley de los Trabajadores al Servicio de los Gobiernos Estatal y Municipales, así como de los organismos descentralizados para el Estado de Hidalgo; Ejercer las funciones que en materia de Trabajo correspondan al Ejecutivo del Estado; Promover el incremento de la productividad del trabajo; Promover el desarrollo de la capacitación y el adiestramiento para y en el trabajo, que requiera los sectores productivos del Estado, en coordinación con las dependencias y entidades de la Administración Pública Estatal; Visitar los centros de trabajo para constatar que se cumplan con las condiciones que establece la Ley Federal del Trabajo y normas que de ella se deriven; Apoyar y fomentar relaciones con asociaciones obrero patronales del Estado, procurando la conciliación de sus intereses; Promover la conciliación de los conflictos que surjan entre trabajadores y patrones; Formular, fomentar, coordinar y ejecutar políticas y programas en materia laboral en el Estado, tendientes a la protección y mejoramiento de las condiciones laborales de los trabajadores.</p>
              <div className='btn_organigrama'>
                <button type="button" onClick={organigrama} className="btn btn-primary">Organigrama</button>
                <button type="button" onClick={normatividad} className="btn btn-primary">Normatividad</button>          
                <button type="button" onClick={misionvision} className="btn btn-primary btn_alin" >Misión y Visión</button>
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/Strabajohgo' target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
                <a href='https://www.instagram.com/strabajohgo/' target="_blank"><i class="fa-brands fa-instagram"></i></a>
                <a href='https://twitter.com/strabajohgo' target="_blank"><i class="fa-brands fa-twitter"></i></a>
              </div>
          </div>
        </div>
        
        <div className='secretaria_funciones'>
            <h3 className='title'>SISTEMA ALTERNO DE INSPECCIÓN LABORAL</h3>
            <hr className='hr-gob'/>
            <section class="main-banner">
                <div class="grid-container">
                    <div class="graphic">
                        <img class="graphic-go absolute" src={"img/1.png"}/>
                        <div class="graphic-sail absolute">
                          
                            <img class="trabajador absolute" src={"img/trabajador.png"}/>
                        </div>
                        <div class="graphic-sail-2 absolute">
                          
                            <img class="sail absolute" src={"img/sail.png"}/>
                        </div>
                    </div>
                    <div >
                    <hr className='hr-gob'/>
                    <p>
                            El Sistema Alterno de Inspección Laboral es un mecanismo que ayuda a los centros de trabajo a dar cumplimiento a las obligaciones patronales que la Ley Federal del Trabajo establece, a través de un diagnóstico sencillo, transparente, amigable y gratuito, en el cual les dará conocer la situación en la que se encuentran y cuyo resultado se traduce en un esquema que les permita regularizarse a través del acompañamiento de asesoría en su cumplimiento a la normativa laboral.
                    
                            </p> 
                            <div className='btn_organigrama'>
                        <button type="button" onClick={sailsystem} className="btn btn-primary">Solicitar inscripción al SAIL</button>
                        
                      </div>
                    </div>
                </div>
          </section>
      </div>
        
      <p><br/><br/></p>
        <UltimasNoticias/>
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
            <hr className='hr-gob'/>
          </div>
          <div className='section_notes'>


           {
              titular.map((item, index) =>(
                  <>
                    <div key={ index } className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función del Secretario</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda del Secretario</Link>
                        </div>
                      </div>
                    </div>
                  </>
              ))
            }
          </div>

              

        </div>
        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob'/>
            </div>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1873.8170312755199!2d-98.74502545928299!3d20.065764772079934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1a76c91eb0475%3A0xa4d15461ed39f95f!2sSecretaria%20del%20Trabajo%20y%20Previsi%C3%B3n%20Social!5e0!3m2!1ses!2smx!4v1673296444553!5m2!1ses!2smx" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    width="100%" 
                    height="300" 
                    frameborder="0" 
                    style={{border:0, marginBottom:50}} 
                    allowfullscreen>
            </iframe>
          </div>
        </div>   
      </div>
    </>
  )
}

function misionvision(){
  window.open('http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/MVO_STPSH.pdf')
}

function organigrama(){
  window.open('http://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir1/fraccionII/ESTRUCTURA_ORGANICA_FEB_2025.pdf')
}

function normatividad(){
  window.open('./Transparencia/Rubros/DetalleRubro/Normatividad')
}

function sailsystem(){
  window.open('./Sail')
}


export default Inicio